import { render, staticRenderFns } from "./tagRetrieval.vue?vue&type=template&id=4c031bb0&scoped=true"
import script from "./tagRetrieval.vue?vue&type=script&lang=js"
export * from "./tagRetrieval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c031bb0",
  null
  
)

export default component.exports